import { observer } from 'mobx-react-lite';
import { ParameterRender } from './ParameterRender';
import { Box, Button } from '@apia/theme';
import { ParametersGroupRenderer } from './types';
import { toJS } from 'mobx';
import { getLabel } from '@apia/util';

export const ParametersTable: ParametersGroupRenderer = observer(
  ({ group }) => {
    const maxIndex = Math.max(
      ...Object.values(group.parameters).map((p) => p.state.values.length),
    );
    const indices = Array.from({ length: maxIndex }, (_, i) => i);

    return (
      <Box
        as="table"
        variant="layout.common.tables.secondary"
        sx={{
          gridColumn: 'span 4',
        }}
      >
        <thead>
          <tr>
            {Object.values(group.parameters).map((p) =>
              p.state.type !== 'hidden' ? (
                <th sx={toJS(p.state.cssProps?.TH)} key={p.state.name}>
                  {p.state.title}
                </th>
              ) : null,
            )}
          </tr>
        </thead>
        <tbody>
          {indices.map((index) => (
            <tr
              key={index}
              onClick={() => {
                group.selection.clear();
                group.selection.add(index);
              }}
              className={group.selection.has(index) ? 'selected' : ''}
            >
              {Object.entries(group.parameters).map(([name, parameter]) =>
                parameter.state.type !== 'hidden' ? (
                  <td key={name}>
                    <ParameterRender
                      omitLabel
                      index={index}
                      parameter={parameter}
                    />
                  </td>
                ) : null,
              )}
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={Object.keys(group.parameters).length}>
              <Button
                onClick={() => {
                  Object.values(group.parameters)[0]?.state.values.push('');
                }}
              >
                {getLabel('btnAgr').text}
              </Button>
              <Button
                onClick={() => {
                  for (let i = maxIndex; i >= 0; i--) {
                    if (group.selection.has(i)) {
                      Object.values(group.parameters).forEach((c) =>
                        c.state.values.splice(i, 1),
                      );
                    }
                  }
                  group.selection.clear();
                }}
              >
                {getLabel('btnDel').text}
              </Button>
            </td>
          </tr>
        </tfoot>
      </Box>
    );
  },
);
